import { Wrap } from './ManageLoaderStyles'
import { RiverLogoLoader } from './RiverLogoLoader'
import { MiniLoader } from './MiniLoader'
import { MediumLoader } from './MediumLoader'

interface ManageLoaderProps {
  loadingMessage?: string
  extraStyles?: string
}

const ManageLoader = ({
  loadingMessage = '',
  extraStyles = '',
}: ManageLoaderProps) => {
  return (
    <Wrap data-testid="manage-loader" extraStyles={extraStyles}>
      <RiverLogoLoader loadingMessage={loadingMessage} />
    </Wrap>
  )
}

export { ManageLoader, MiniLoader, MediumLoader }
